import { Box, IconButton, Modal, Stack, Switch, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { GridPinnedColumns } from '@mui/x-data-grid-premium';
import { SectionHeader } from './massActions';
import { GridColumns } from 'shared/types';

interface DataGridProPinColumnsModalProps<T> {
    columns: GridColumns<T>;
    pinColumnsModalOpen: boolean;
    pinAllColumns?: boolean;
    pinnedColumns: GridPinnedColumns;
    handlePinColumnsModalClose: (event: any) => void;
    pinColumn: (field: string) => void;
}

export function DataGridProPinColumnsModal<T>({
    columns,
    pinColumnsModalOpen,
    pinAllColumns,
    pinnedColumns,
    handlePinColumnsModalClose,
    pinColumn
}: DataGridProPinColumnsModalProps<T>) {

    const modalStyle = {
        position: 'absolute' as 'absolute',
        top: '10%',
        left: '10%',
        width: '80%',
        bgcolor: 'background.paper',
        border: '2px solid #CCC',
        boxSizing: 'border-box',
        boxShadow: 24,
        p: 0,
        m: 0,
    };

    return (
        <Modal
                open={pinColumnsModalOpen}
                onClose={handlePinColumnsModalClose}
                aria-labelledby='modal-pin-column-title'
                aria-describedby='modal-pin-column-description'
            >
                <Stack sx={modalStyle}>
                    <SectionHeader>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                width: '100%',
                                gap: 6,
                                p: 1,
                            }}
                        >
                            <Typography variant={'h5'}>Pin Columns</Typography>
                            <IconButton onClick={handlePinColumnsModalClose}>
                                <CloseIcon sx={{ color: 'white' }} />
                            </IconButton>
                        </Box>
                    </SectionHeader>
                    <Stack sx={{ p: 2, flexDirection: 'row', flexWrap: 'wrap' }}>
                        {
                            columns.filter(c => !c.hide && (pinAllColumns || c.pinnable)).map(column =>
                                (
                                    <div key={column.field}>
                                    {
                                        (!column.headerClassName?.toString().includes('grouped-header'))?
                                            <>
                                                <Switch 
                                                    onClick={() => pinColumn(column.field)} 
                                                    defaultChecked={pinnedColumns.left?.some(p => p === column.field)} />
                                                    <b>{column.headerName || column.field || ''}</b>
                                            </> :
                                            <div style={{padding: '5px 0'}}>
                                                <span>/</span>
                                                <b>{column.headerName || ''}</b>
                                            </div>
                                    }
                                    </div>

                                ) 
                            )
                        }
                    </Stack>
                </Stack>
            </Modal>
    );
}